import { render, staticRenderFns } from "./KeyValueChart.vue?vue&type=template&id=318a13b4&"
import script from "./KeyValueChart.vue?vue&type=script&lang=js&"
export * from "./KeyValueChart.vue?vue&type=script&lang=js&"
import style0 from "./KeyValueChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports